import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { I18nextProvider } from 'react-i18next'
import i18n from './Assets/Lang/i18n'
import { store } from './Backend/Redux/store/configureStore'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import CoreLayoutContainer from 'Frontend/Container/CoreLayoutContainer'
import * as serviceWorker from './serviceWorker'
import { KEY_STORE } from 'Utils/globalConstants'
import * as actions from 'Backend/Redux/actions/globalActions'
import init from 'Backend/Redux/lib/initState'
import { checkLocalStoreToRedux } from 'Backend/Redux/lib/reducerConfig'
import ReduxServices from 'Utils/globalRedux'
import 'antd/dist/antd.css';
import {web3} from 'Backend/Web3'

export default class App extends React.PureComponent {
  async componentDidMount () {
    let storageRedux = [
      { key: KEY_STORE.USER_AUTHENTICATION, action: actions.setUserAuthentication, init: init.userAuth }
    ]
    const promiseArr = storageRedux.map(async (item) => {
      await checkLocalStoreToRedux(store, item.key, item.action, item.init)
    })
    await Promise.all(promiseArr)

    setTimeout(() => {
      ReduxServices.refreshMetaMask();
    }, 500);
    if(web3) {
      web3.currentProvider.on("accountsChanged", function (accounts) {
        console.log("accountsChanged");
        ReduxServices.refreshMetaMask();
      });
      web3.currentProvider.on("networkChanged", function (accounts) {
        ReduxServices.refreshMetaMask();
      });
      web3.currentProvider.on("chainChanged", function (accounts) {
        ReduxServices.refreshMetaMask();
      });
    }
  }
  render () {
    return (
      <Provider store={store}>
        <Router>
          <Switch>
            <Route path="/" name="Home" component={CoreLayoutContainer} />
          </Switch>
        </Router>
      </Provider>
    )
  }
}

ReactDOM.render(<I18nextProvider i18n={ i18n() }>
  <App />
</I18nextProvider>, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
